var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconExpandArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 6,
  viewBox: "0 0 5 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.84151 1.42206L2.89002 3.34337C2.67503 3.55503 2.32773 3.55503 2.11273 3.34337L0.161246 1.42206C-0.0537486 1.21039 -0.0537486 0.868467 0.161246 0.656799C0.37624 0.44513 0.723539 0.44513 0.938534 0.656799L2.49862 2.19276L4.05871 0.656799C4.27371 0.44513 4.621 0.44513 4.836 0.656799C5.05099 0.868467 5.05099 1.21039 4.836 1.42206H4.84151Z",
  fill: "#414141"
})));
export default SvgIconExpandArrow;